import {Box} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PullToRefresh from 'react-simple-pull-to-refresh';
import {WebsiteHeader, AppBar, Loading} from '../components';
import {initialApis} from '../services/apis/global';
import {useAppDispatch, useAppSelector} from '../services/redux/store';

export default function Layout({children}: {children: React.ReactNode}) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const loading = useAppSelector((state) => state.loadingReducer.loading);
  return (
    <>
      <PullToRefresh onRefresh={async () => initialApis(dispatch, navigate)}>
        <Box sx={{display: 'flex', flexDirection: 'column', minHeight: '100vh'}}>
          <WebsiteHeader />
          <Box component="main" flexGrow={1}>
            {children}
            <AppBar />
          </Box>
        </Box>
      </PullToRefresh>
      {loading && <Loading/>}
    </>
  );
}
